import { PageSection } from '@/features/jobs/details/components/PageLayout'
import { SectionHeadline } from '@/components/SectionHeadline'
import {
  Card,
  CardContent,
  CardContentDecoration,
  CardSubtitle,
  CardTitle,
} from '@/components/Card'
import { Icon } from '@/components/Icon'
import { dateFormatters } from '@/utils/date-util'

export interface ExtensionFiledSectionProps {
  /**
   * The date the extension was filed.
   */
  filedAt: Date

  /**
   * Test ID attribute.
   */
  testId?: string
}

/**
 * Informs the user that an extension was filed for the job.
 */
export function ExtensionFiledSection({
  filedAt,
  testId,
}: ExtensionFiledSectionProps) {
  return (
    <PageSection testId={testId}>
      <SectionHeadline>Extension</SectionHeadline>
      <Card>
        <CardContent>
          <CardContentDecoration spacing="md">
            <Icon name="calendar-tick" variant="active" />
          </CardContentDecoration>
          <CardTitle>An extension was filed</CardTitle>
          <CardSubtitle variant="description">
            Filed on {dateFormatters.dateMedium.format(filedAt)}
          </CardSubtitle>
        </CardContent>
      </Card>
    </PageSection>
  )
}
